const retryWithBackoff = async (fn, maxRetries = 3, baseDelay = 1500) => {
  for (let attempt = 0; attempt <= maxRetries; attempt++) {
    try {
      return await fn();
    } catch (error) {
      const status = error?.response?.status;
      if (status >= 400 && status < 500) {
        throw error;
      }
      if (attempt === maxRetries) {
        throw error;
      }
      const backoff = baseDelay * Math.pow(2, attempt);
      const jitter = backoff * (0.5 + Math.random() * 0.5);
      await new Promise((resolve) => setTimeout(resolve, jitter));
    }
  }
};

export default retryWithBackoff;
